export const IsolvedLogoIcon = (props: {
  classes: {
    svg: string;
  };
}) => {
  return (
    <svg
      className={props.classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill="#FFFFFF"
        d="M361.6,56.2v-5.7c0-2.9-2.4-5.3-5.3-5.3H238.1c-2.9,0-5.3,2.4-5.3,5.3v97.4c0,2.2,1.4,4.2,3.5,5
          c45.6,16.8,76,61.2,72.7,112.3c-3,45.8-32.5,83-72.8,97.9c-2.1,0.8-3.5,2.7-3.5,5v87.7c0,11.1,5.4,11.1,10.7,11.1h107.9
          c8.8,0.1,10.3-3.1,10.3-11.4C361.5,315.9,361.6,195.7,361.6,56.2L361.6,56.2z"
      />
      <path
        fill="#E50082"
        d="M194.5,332.1c41,0,74.2-33.2,74.2-74.2c0-41-33.2-74.2-74.2-74.2c-41,0-74.2,33.2-74.2,74.2
          C120.3,298.9,153.5,332.1,194.5,332.1z"
      />
    </svg>
  );
};
